import { padNumberToLength } from '../utils/pad-number-to-length';
/**
 * Returns a numerical representation of the second: 0, 1, ..., 59
 * @hidden
 */
export const getSecondNumeric = ({ date }) => {
    // don't need to localise as seconds do not change between time zones.
    return date.getSeconds();
};
/**
 * Returns a two-digit string representation of the second: 00, 01, ..., 59
 * @hidden
 */
export const getSecondTwoDigit = (params) => {
    const seconds = getSecondNumeric(params);
    return padNumberToLength(seconds, 2);
};
//# sourceMappingURL=second.js.map